import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VueAnalytics from 'vue-analytics';

import i18n from './lang/lang';
import VeeValidate from 'vee-validate';
import { messages } from './lang/heValidation';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import 'vue-select/dist/vue-select.css';
import '@/assets/styles/app.scss';
import VueProgressBar from 'vue-progressbar';
import { mixin as clickaway } from 'vue-clickaway';
import IdleVue from 'idle-vue';
import vDatePicker from 'vuejs-datepicker';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import LinkWidget from '@/components/payroll/LinkWidget.vue';
import ButtonWidget from '@/components/payroll/ButtonWidget.vue';
import TextFieldWidget from '@/components/payroll/TextFieldWidget.vue';
import DateFieldWidget from '@/components/date-field-widget/DateFieldWidget.component.vue';
import RadioGroupWidget from '@/components/payroll/RadioGroupWidget';
import CheckboxGroupWidget from '@/components/payroll/CheckboxGroupWidget.vue';
import CheckboxWidget from '@/components/payroll/CheckboxWidget.vue';
import SelectFieldWidget from '@/components/payroll/SelectFieldWidget.vue';
import FileUploadWidget from '@/components/payroll/FileUploadWidget.vue';
import PaginationWidget from '@/components/payroll/PaginationWidget';
import DataTableWidget from '@/components/data-table-widget/DataTableWidget.component.vue';
import TooltipWidget from '@/components/payroll/TooltipWidget.vue';
import FormWidget from '@/components/payroll/FormWidget.vue';
import PasswordFieldWidget from '@/components/payroll/PasswordFieldWidget.vue';
import PasswordInstructionWidget from '@/components/payroll/PasswordInstructionWidget.vue';
import ModalComponent from '@/components/modal-component/ModalComponent.component.vue';
import vSelect from 'vue-select';
import VueFormWizard from 'vue-form-wizard';
import themify from '@icon/themify-icons/themify-icons.css';
import '@/globals/filters';
import Closable from '@/globals/closable-directive';
import clickClosable from '@/globals/clickclosable-directive';
import MdiComponent from '@/components/widgets/material-design-icons/MaterialDesignIcons.component.vue';
import DropdownMenuComponent from '@/components/widgets/dropdown/DropdownMenu.component.vue';
import MultiLevelMenu from '@/components/widgets/dropdown/MultiLevelMenu.component.vue';
import LoginCardTopComponent from '@/views/authentication/loginCardTop/LoginCardTop.component.vue';
import LoginWelcomeComponent from '@/views/authentication/loginWelcome/LoginWelcome.component.vue';
import LoginHelpLinkComponent from '@/views/authentication/loginHelpLink/LoginHelpLink.component.vue';
import NewDataSearchWidget from '@/components/widgets/NewDataSearchWidget.vue';
import DataSearchWidget from '@/components/widgets/DataSearchWidget.vue';
import DatePickerWidget from '@/components/payroll/DatePickerWidget.vue';
import Notifications from 'vue-notification';
import VueCarousel from 'vue-carousel';
import BarChartComponent from '@/components/charts/BarChart.component.vue';
import DoughnutChartComponent from '@/components/charts/DoughnutChart.component.vue';
import DateInputWidget from '@/components/payroll/DateInputWidget.vue';
import TextAreaWidget from '@/components/payroll/TextAreaWidget.vue';
import NewTextAreaWidget from '@/components/payroll/NewTextAreaWidget.vue';
import NewSelectFieldWidget from '@/components/payroll/NewSelectFieldWidget.vue';
import FlatDropdownMenuComponent from '@/components/widgets/dropdown/FlatDropdownMenu.component.vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import MiddleEllipsisText from '@/components/payroll/MiddleEllipsisText.vue';
import { ACCESS_TOKEN, AUTHORIZATION_ROOT } from '@/types/authorization.types';
import { AUTHENTICATION_ROOT, GOV, USER_DETAILS } from '@/types/authentication.types';
import RecaptchaV2Component from '@/views/authentication/components/recaptcha-v2/recaptcha-v2.component.vue';
import { SYSTEM_ROOT, TOKEN } from '@/types/system.types';
import { RESET_STORE } from '@/types/store.types';
import { LOBBY_ACCESSIBLE, LOBBY_ROOT } from '@/types/lobby.types';
import InfiniteSelectFieldWidget from '@/components/payroll/InfiniteSelectFieldWidget.vue';
import { GlobalVariables } from '@/globals/global-variables';
import TestSelectFieldWidget from '@/components/payroll/TestSelectFieldWidget.vue';
import AuthLoading from '@/components/loading/AuthLoading.vue';
import IpRangeFieldComponent from '@/components/payroll/ipRangeFieldComponent.vue';
import IpFieldWidget from '@/components/payroll/ipFieldWidget.vue';
import TermsAndPrivacyComponent from '@/views/terms-and-privacy/TermsAndPrivacyComponent.component';

Vue.component('v-select', vSelect);
Vue.component('text-field-widget', TextFieldWidget);
Vue.component('ip-field-widget', IpFieldWidget);
Vue.component('ip-range-field-widget', IpRangeFieldComponent);
Vue.component('text-area-field-widget', TextAreaWidget);
Vue.component('new-text-area-field-widget', NewTextAreaWidget);
Vue.component('v-date-picker', vDatePicker);
Vue.component('date-picker-widget', DatePickerWidget);
Vue.component('date-field-widget', DateFieldWidget);
Vue.component('date-input-widget', DateInputWidget);
Vue.component('radio-group-widget', RadioGroupWidget);
Vue.component('checkbox-group-widget', CheckboxGroupWidget);
Vue.component('checkbox-widget', CheckboxWidget);
Vue.component('select-field-widget', SelectFieldWidget);
Vue.component('new-select-field-widget', NewSelectFieldWidget);
Vue.component('test-select-field-widget', TestSelectFieldWidget);
Vue.component('infinite-select-field-widget', InfiniteSelectFieldWidget);
Vue.component('upload-file', FileUploadWidget);
Vue.component('pagination', PaginationWidget);
Vue.component('data-table-widget', DataTableWidget);
Vue.component('data-search-widget', DataSearchWidget);
Vue.component('new-data-search-widget', NewDataSearchWidget);
Vue.component('tooltip-widget', TooltipWidget);
Vue.component('form-widget', FormWidget);
Vue.component('password-field-widget', PasswordFieldWidget);
Vue.component('password-instruction-widget', PasswordInstructionWidget);
Vue.component('login-card-top', LoginCardTopComponent);
Vue.component('login-welcome', LoginWelcomeComponent);
Vue.component('login-help-link', LoginHelpLinkComponent);
Vue.component('modal-component', ModalComponent);
Vue.component('d-menu', DropdownMenuComponent);
Vue.component('flat-d-menu', FlatDropdownMenuComponent);
Vue.component('level-menu', MultiLevelMenu);
Vue.directive('closable', Closable);
Vue.directive('click-closable', clickClosable);
Vue.component('mdi-icon', MdiComponent);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('button-widget', ButtonWidget);
Vue.component('link-widget', LinkWidget);
Vue.component('bar-chart', BarChartComponent);
Vue.component('doughnut-chart', DoughnutChartComponent);
Vue.component('middle-ellipsis-text', MiddleEllipsisText);
Vue.component('payroll-recaptcha-v2', RecaptchaV2Component);
Vue.component('auth-loading', AuthLoading);
Vue.component('terms-and-privacy', TermsAndPrivacyComponent);

Vue.use(VueFormWizard, themify);
Vue.use(Notifications);
Vue.use(VueCarousel);

Vue.mixin(clickaway);

library.add(fas, far, fal);

// For more options see below
if (process.env.VUE_APP_RECAPTCHA_SITE_KEY) {
  Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    useRecaptchaNet: true,
    autoHideBadge: true,
  });
}

/**** vee validate *****/
Vue.use(VeeValidate, {
  inject: false,
  locale: 'he',
  dictionary: {
    he: { messages },
  },
});

/**** progress bar *****/
const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
};

Vue.use(VueProgressBar, options);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  const systemTokenChecker = store.getters[SYSTEM_ROOT + TOKEN];
  let accessTokenChecker = store.getters[AUTHORIZATION_ROOT + ACCESS_TOKEN];
  const govChecker = store.getters[AUTHENTICATION_ROOT + GOV];
  if (to.matched.some((record: any) => record.meta.authNotRequired)) {
    if (to.matched.some((record: any) => record.meta.isMaintenance)) {
      next();
      store.dispatch(RESET_STORE);
    } else if (systemTokenChecker && to.matched.some((record: any) => record.meta.isSystemInfoPages)) {
      if (to.matched.length > 0) {
        next({ name: 'system-info-page' });
      } else {
        next({ name: 'system-info-login' });
      }
    } else if (accessTokenChecker) {
      store.dispatch(LOBBY_ROOT + LOBBY_ACCESSIBLE, null, { root: true })
        .then(() => {
          if (to.matched.some((record: any) => record.meta.isSystemInfoPages)) {
            next();
          } else if (to.name === 'expired-password' && to.params.passwordExpired) {
            next();
          } else {
            next({ name: 'lobby' });
          }
        })
        .catch(() => {
          accessTokenChecker = null;
          next();
        });
    } else {
      next();
    }
    //   store.dispatch(LOBBY_ROOT + LOBBY_ACCESSIBLE, null, { root: true })
    //     .then(() => {
    //       if (systemTokenChecker && to.matched.length > 0) {
    //         next({ name: 'system-info-page' });
    //       } else if (to.matched.some((record: any) => record.meta.isSystemInfoPages)) {
    //         next();
    //       } else if (accessTokenChecker && to.matched.length > 0) {
    //         next({ name: 'lobby' });
    //       }
    //     })
    //     .catch(() => {
    //       accessTokenChecker = null;
    //       systemTokenChecker = null;
    //       next();
    //     });
  } else if (((accessTokenChecker || systemTokenChecker) && to.matched.length > 0)) {
    next();
  } else {
    store.dispatch(RESET_STORE);
    if (to.matched.some((record: any) => record.meta.isSystemInfoPages)) {
      router.push({ name: 'system-info-login' });
    } else {
      const loginRouting = govChecker ? 'login?c=gov' : 'login';
      router.push({ path: loginRouting });
    }
  }
});

const eventsHub = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

export { eventsHub };

/**** idle plugin *****/
Vue.use(IdleVue, { store, idleTime: GlobalVariables.IDLE_TIME });
/*************************/

/**** Sentry *****/
if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SENTRY_AUTH_TOKEN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    release: process.env.VUE_APP_SENTRY_RELEASE + '@' + process.env.VUE_APP_BUILD_VERSION_NUMBER,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    attachProps: true,
    logErrors: true,
    denyUrls: [
      /chunk-vendors\..*\.js/,
      /https?:\/\/.*\.googletagmanager\.com\/.*/,
      /recaptcha/,
      /https?:\/\/.*\.google\.com\/.*/,
    ],
    beforeSend: (event, hint) => {
      const userDetails = store.getters['authentication/userDetails'];
      const indexNum = (userDetails || { indexNum: 'Unknown' }).indexNum || 'Unknown';
      const userId = (userDetails || { userId: 'Unknown' }).userId || 'Unknown';
      const userName = (userDetails || { fullName: 'Unknown' }).fullName || 'Unknown';

      event.tags = { ...event.tags, indexNum, userId, userName };

      return event;
    }
  });

  Vue.config.errorHandler = (err: Error, vm: Vue, info: string): void => {
    Sentry.captureException(err);
  };
}
/*************************/
/**** Google Analytics *****/
if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_GOOGLE_ANALYTICS_UA) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_UA,
    router,
  });
}
/*************************/

